// src/components/inspector/InspectorRouteGuard.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useInspectorAuth } from '../../context/InspectorAuthContext';

export default function InspectorRouteGuard({ children }) {
  const { inspector, loading } = useInspectorAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: '#0f172a', color: '#fff', fontFamily: 'sans-serif'
      }}>
        Loading...
      </div>
    );
  }

  if (!inspector) return <Navigate to="/inspector/login" replace />;
  return children;
}